<template>
  <div class="card-header">
    <div class="header-top">
      <div class="resource_icon">
        <i class="bi bi-database-fill" />
      </div>
      <div class="resource_format">
        {{ resource.type=='postgis'?'PostGIS':'PostGres' }}
      </div>
      <div class="resource_name">
        {{ `${resource[resource.type].schema_name}.${resource[resource.type].table_name}` }}
      </div>
    </div>
    <div class="header-bottom">
      <slot name="publication" />
      <div
        class="form-group resource-form-footer"
      >
        <b-button
          variant="outline-secondary"
          @click="isUpdateDatastoreResourceModalOpen = true"
        >
          {{ $t('buttons.edit') }}
        </b-button>
      </div>
    </div>
    <UpdateDatastoreModal
      v-if="isUpdateDatastoreResourceModalOpen"
      :open="isUpdateDatastoreResourceModalOpen"
      :format="resource.type"
      :resource="editResource"
      @hide="isUpdateDatastoreResourceModalOpen = false"
      @update="modifyDatastore"
    />
  </div>
</template>

<script>
import UpdateDatastoreModal from '@/components/Resource/modals/UpdateDatastoreModal.vue';
import Resource from '../../../models/resource.js';
export default {
  name: 'DatastoreEditor',

  components: {
    UpdateDatastoreModal
  },

  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      // modals
      editResource:this.editResource,
      isUpdateDatastoreResourceModalOpen: false,
    };
  },

  mounted() {
    this.editResource=new Resource({ ...this.resource });
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', () => {
      this.isUpdateDatastoreResourceModalOpen = false;
    });
  },

  methods: {
    
    modifyDatastore(e) {
      this.resource=e;
      this.$emit('modify', {
        resource:this.resource,
      });
      this.isUpdateDatastoreResourceModalOpen = false;
    },

    deleteResource() {
      this.$emit('delete');
    },
  }

};
</script>